import React, { useEffect, useState } from 'react';

const RandomNumber = ({ value, className, style }) => {
    return <span style={style} className={className}>{value}</span>;
};

const Random = ({ sizeDigit, className, style }) => {
    const [digits, setDigits] = useState(
        Array(sizeDigit).fill(0)
    );

    useEffect(() => {
        const interval = setInterval(() => {
            setDigits(prev =>
                prev.map(() => Math.floor(Math.random() * 10))
            );
        }, 65);

        return () => clearInterval(interval);
    }, [sizeDigit]);

    return digits.map((digit, i) => (
        <RandomNumber style={style} key={i} value={digit} className={className} />
    ));
};

export default Random;
